import React from 'react';

import { Typography, notification } from 'antd';
import styled from 'styled-components';
import {
  CheckmarkCircle20Regular,
  Dismiss12Regular,
} from '@fluentui/react-icons';
import { TextProps } from '../StyledInterface';
import COLOR from '../Colors';

const { Text } = Typography;

const DISMISS = 'Dismiss';
const fontFamily = 'Nunito';
const notficiationWidth = 400;
const borderRadius = 8;

export const CustomText = styled(Text)`
  color: ${(props: TextProps) => props.color || COLOR.GREY_10} !important;
  font-size: ${(props: TextProps) => `${props.fontSize || 12}px`} !important;
  line-height: ${(props: TextProps) =>
    props.fontSize ? `${props.fontSize + 8}px` : '22px'} !important;
  font-weight: ${(props: TextProps) => props.fontWeight || '500'} !important;
  display: inline !important;
`;

export const showSuccessNotficiation = (
  message: string,
  description?: string
) => {
  const notificationStyleObj = {
    width: notficiationWidth,
    backgroundColor: '#EFFDF3',
    border: `1px solid #A7F0BA`,
    borderRadius: `${borderRadius}px`,
    fontFamily,
  };

  notification.success({
    icon: (
      <CheckmarkCircle20Regular
        color="#1D813A"
        style={{ marginTop: '3px', marginLeft: '10px' }}
      />
    ),
    message: (
      <CustomText fontWeight={500} color={COLOR.GREY_8}>
        {message}
      </CustomText>
    ),
    description: (
      <CustomText fontWeight={400} color={COLOR.GREY_8} fontSize={12}>
        {description}
      </CustomText>
    ),
    closeIcon: (
      <Dismiss12Regular style={{ marginTop: '6px' }} color={COLOR.GREY_12} />
    ),
    style: notificationStyleObj,
    duration: 3,
  });
};

export const showErrorNotification = (
  message: string,
  errorDescription?: string
) => {
  const notificationStyleObj = {
    width: notficiationWidth,
    // backgroundColor: COLOR.RED_1,
    border: `1px solid ${COLOR.RED_2}`,
    borderRadius: `${borderRadius}px`,
    fontFamily,
  };

  notification.error({
    message: (
      <CustomText fontWeight={400} color={COLOR.RED_2}>
        {message}
      </CustomText>
    ),
    description: (
      <CustomText fontWeight={400} color={COLOR.RED_2} fontSize={12}>
        {errorDescription}
      </CustomText>
    ),
    style: notificationStyleObj,
    closeIcon: (
      <CustomText fontSize={12} color={COLOR.RED_2}>
        {DISMISS}
      </CustomText>
    ),
  });
};
